/**
 * Seeing the ad behind a Meta campaign (2 Oct 2026).
 *
 * A Meta campaign arrives as a bare number and an ad cannot be opened from that number.
 * Meta's public Ad Library shows every ad we run, finished ones included, and each has a
 * "Library ID" that makes a direct link. The ad to pick is the one whose start date is the
 * campaign's first hit.
 *
 * The server (functions/handlers/campaignNaming.js) is the authority on what is stored;
 * parseAdLibraryId here only gives the answer before the round trip.
 */

/** Every ClozeSure ad in the Library, active or finished. */
export const AD_LIBRARY_SEARCH_URL =
  "https://www.facebook.com/ads/library/?active_status=all&ad_type=all&country=GB&q=clozesure&search_type=keyword_unordered&media_type=all";

/** The Library ID from a bare id or an Ad Library link; null when it is neither. */
export function parseAdLibraryId(input) {
  const raw = String(input == null ? "" : input).trim();
  if (/^\d{10,20}$/.test(raw)) return raw;
  const m = raw.match(
    /^https:\/\/(?:www\.|m\.)?facebook\.com\/ads\/library\/?\?(?:[^#\s]*&)?id=(\d{10,20})(?:[&#]|$)/i,
  );
  return m ? m[1] : null;
}

/**
 * The ad in Meta's Ads Manager, for someone who has access to the ad account. A Meta campaign
 * id is the campaign the ad sits in (one campaign, one ad), so the campaign is selected.
 * ⚠️ No ad account is named: Ads Manager opens the signed-in person's own account, and shows
 * nothing useful to anyone without access. Null unless the id is all digits.
 */
export function adsManagerUrl(campaignId) {
  return /^\d{10,20}$/.test(String(campaignId || ""))
    ? `https://adsmanager.facebook.com/adsmanager/manage/ads?selected_campaign_ids=${campaignId}`
    : null;
}

/** The direct link to one ad. Null unless the id is all digits: it goes into an href. */
export function adLibraryUrl(id) {
  return /^\d{10,20}$/.test(String(id || ""))
    ? `https://www.facebook.com/ads/library/?id=${id}`
    : null;
}
